import React from "react"
import {Row} from "react-bootstrap"
import styled from "styled-components"
import PropTypes from "prop-types"

import {H3} from "@irati/ui/src/Headings"
import {FormattedMessage} from "@irati/utils/lang"
import GetInsWizard from "@irati/insights/apollo/client/query/InsWizard"
import {questionFieldsFragment} from "@irati/insights/apollo/gql/fragments/question"
import GetDeletedQuestionGroup from "@irati/insights/apollo/query/wizard/DeletedQuestionGroup"
import getActiveQuestions from "@irati/insights/apollo/helpers/question/getActiveQuestions"
import UpdateInsWizard from "@irati/insights/apollo/client/mutation/InsWizard"
import GetCycleWizard from "@irati/insights/apollo/query/wizard/Cycle"

import AddQuestion from "./AddQuestion"
import QuestionEditor from "./QuestionEditor"
import OpenFeedback from "./OpenFeedback"

const StyledRow = styled(Row)`
  padding-top: 15px;
`

const PageTitle = styled(H3)`
  padding: 0 0 25px 15px;
`

const QuestionManagerCustom = ({disabled}) => {
  return (
    <GetDeletedQuestionGroup>
      {({questionGroup: {uuid: deletedQuestionGroupUuid}}) => {
        return (
          <GetInsWizard>
            {({questions, client}) => {
              const onSave = (q, value) => {
                client.writeFragment({
                  id: `Question@${q.uuid}`,
                  fragment: questionFieldsFragment,
                  data: {...q, text: value}
                })
              }
              const onDelete = (q) => {
                client.writeFragment({
                  id: `Question@${q.uuid}`,
                  fragment: questionFieldsFragment,
                  data: {...q, groupUuids: [deletedQuestionGroupUuid]}
                })
              }
              const activeQuestions = getActiveQuestions(questions, deletedQuestionGroupUuid)
              return (
                <div>
                  <H3><FormattedMessage id="insights.customSurvey.scaleQuestions" /></H3>
                  <StyledRow>
                    {activeQuestions.map((question) =>
                      <QuestionEditor disabled={disabled} key={question.uuid} question={question} onSave={onSave} onDelete={onDelete} />)}
                  </StyledRow>
                  <StyledRow>
                    <AddQuestion disabled={disabled} />
                  </StyledRow>
                  <StyledRow>
                    <PageTitle><FormattedMessage id="insights.customSurvey.openFeedback.title" /></PageTitle>
                    <UpdateInsWizard>
                      {(_, {cycle, updateCycle}) => {
                        return (
                          <GetCycleWizard>
                            {() => {
                              return (
                                <OpenFeedback disabled={disabled} cycle={cycle} onChange={updateCycle} />
                              )
                            }}
                          </GetCycleWizard>
                        )
                      }}
                    </UpdateInsWizard>
                  </StyledRow>
                </div>
              )
            }}
          </GetInsWizard>
        )
      }}
    </GetDeletedQuestionGroup>
  )
}

QuestionManagerCustom.propTypes = {
  disabled: PropTypes.bool
}

QuestionManagerCustom.defaultProps = {
  disabled: false
}

export default QuestionManagerCustom
